const upperCaseRegex = /[A-Z]/u
const lowerCaseRegex = /[a-z]/u
// Special characters should be https://www.ascii-code.com/characters/punctuation-and-symbols
const specialCharactersRegex = /[!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~-]/u
const numberRegex = /\d/u

export const PASSWORD_POLICY_NEW_MIN_LENGTH = 8
export const PASSWORD_POLICY_OLD_MIN_LENGTH = 6

export const hasPasswordMinimumLength = (
  password: string,
  minimumLength: number,
): boolean => password.length >= minimumLength

export const hasPasswordMixedCase = (password: string): boolean => {
  return lowerCaseRegex.test(password) && upperCaseRegex.test(password)
}

export const hasPasswordNumber = (password: string): boolean => {
  return numberRegex.test(password)
}

export const hasPasswordSpecialCharacters = (password: string): boolean => {
  return specialCharactersRegex.test(password)
}

export const satisfiesPasswordComposition = (password: string): boolean => {
  return (
    hasPasswordMixedCase(password) &&
    hasPasswordNumber(password) &&
    hasPasswordSpecialCharacters(password)
  )
}
